import { render, staticRenderFns } from "./OfficialActiveActivityPayNew.vue?vue&type=template&id=1a6adbe2&scoped=true"
import script from "./OfficialActiveActivityPayNew.vue?vue&type=script&lang=js"
export * from "./OfficialActiveActivityPayNew.vue?vue&type=script&lang=js"
import style0 from "./OfficialActiveActivityPayNew.vue?vue&type=style&index=0&id=1a6adbe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6adbe2",
  null
  
)

export default component.exports